import FaqForm from "./FaqForm.container";

export default FaqForm;
